var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarburst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9,9.8c-1.4-0.8-2.8-1.5-4.2-2.2c0.2-1.1,0.6-2.1,0.8-3.2C16.6,4,17,3.3,17,2.8c0-0.1-0.1-0.1-0.2,0 c-0.4,0.1-0.8,0.3-1.2,0.4c-0.6,0.2-1.3,0.4-1.9,0.6l0,0l0,0c-0.4,0.1-0.8,0.3-1.2,0.4c-0.6-0.9-1.1-1.9-1.7-2.9 C10.4,1,10.2,0.3,9.9,0C9.8,0,9.7,0,9.7,0.1C9.5,0.5,9.3,0.9,9.1,1.3C8.8,1.9,8.5,2.5,8.2,3.1l0,0l0,0C8,3.5,7.9,3.8,7.7,4.2 C6.2,3.8,4.7,3,3.1,2.8c-0.2,0,0,0.3,0,0.4c0.3,1.5,0.7,2.9,1.1,4.3C2.9,8.3,1.3,8.9,0,9.8c-0.1,0.2,0.2,0.2,0.3,0.3 C1.6,11,3,11.7,4.3,12.4c-0.4,1.4-0.8,2.8-1.3,4.1c0,0.1-0.2,0.3,0,0.4c-0.1,0.1,0,0.3,0.1,0.2l0,0c0.5-0.2,1.1-0.3,1.6-0.4 c1-0.3,2-0.6,3-0.9c0.6,1.2,1.3,2.5,2,3.7c0.1,0.1,0.1,0.4,0.3,0.3c-0.1,0.1,0.2,0.2,0.2,0l0,0c0.2-0.5,0.6-1,0.9-1.4 c0.5-1,1.1-1.9,1.5-2.9c1.5,0.4,2.9,0.9,4.4,1.4c0.5,0.2-0.1-1.1-0.2-1.3c-0.4-1.2-0.8-2.4-1.2-3.6c1.4-0.8,2.8-1.5,4.2-2.1 C20,10,20,9.8,19.9,9.8L19.9,9.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarburst);
export default __webpack_public_path__ + "static/media/starburst.54da73a44d534595db98fc1de3a9bf33.svg";
export { ForwardRef as ReactComponent };